import { fetchInventoryStockByStockNo } from './fetchByStockNo';

export function fetchInventoryStockByScanCode({
  mode = 'stockNo',
  code,
} = {}) {
  if (mode === 'stockNo') {
    return fetchInventoryStockByStockNo(code);
  }

  throw new Error(`尚未實作庫存掃描模式：${mode}`);
}
